import { render, staticRenderFns } from "./group-status-modal.vue?vue&type=template&id=3986b856&scoped=true"
import script from "./group-status-modal.vue?vue&type=script&lang=js"
export * from "./group-status-modal.vue?vue&type=script&lang=js"
import style0 from "./group-status-modal.vue?vue&type=style&index=0&id=3986b856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986b856",
  null
  
)

export default component.exports